import { ITypedReduxAction } from '../../types/redux/actionType';
import { TNumberInputs, ERoom } from '../../types/filter';
import { TThunkAction } from '../../types/redux/thunk';
import { residentialComplexesIdsChange } from '../residentialComplexesIds';
import { specialPromosBlocksRefresh } from '../specialPromosBlocks';

export enum EFilterActionTypes {
  RegionChange = 'FILTER/REGION_CHANGE',
  RoomsChange = 'FILTER/ROOMS_CHANGE',
  MinPriceChange = 'FILTER/MIN_PRICE_CHANGE',
  MaxPriceChange = 'FILTER/MAX_PRICE_CHANGE',
  MinAreaChange = 'FILTER/MIN_AREA_CHANGE',
  MaxAreaChange = 'FILTER/MAX_AREA_CHANGE',
  DeadlineChange = 'FILTER/DEADLINE_CHANGE',
  DeadlineVariantsChange = 'FILTER/DEADLINE_VARIANTS_CHANGE',
  ReadyApartmentChange = 'FILTER/READY_APARTMENT_CHANGE',
  ApartmentWithDecorationChange = 'FILTER/APARTMENT_WITH_DECORATION_CHANGE',
}

export type TRegionChange = ITypedReduxAction<EFilterActionTypes.RegionChange, number>;
export type TRoomsChange = ITypedReduxAction<EFilterActionTypes.RoomsChange, ERoom[]>;
export type TMinPriceChange = ITypedReduxAction<EFilterActionTypes.MinPriceChange, TNumberInputs>;
export type TMaxPriceChange = ITypedReduxAction<EFilterActionTypes.MaxPriceChange, TNumberInputs>;
export type TMinAreaChange = ITypedReduxAction<EFilterActionTypes.MinAreaChange, TNumberInputs>;
export type TMaxAreaChange = ITypedReduxAction<EFilterActionTypes.MaxAreaChange, TNumberInputs>;
export type TDeadlineChange = ITypedReduxAction<EFilterActionTypes.DeadlineChange, TNumberInputs>;
export type TDeadlineVariantsChange = ITypedReduxAction<EFilterActionTypes.DeadlineVariantsChange, number[]>;
export type TReadyApartmentChange = ITypedReduxAction<EFilterActionTypes.ReadyApartmentChange, boolean>;
export type TApartmentWithDecorationChange = ITypedReduxAction<
  EFilterActionTypes.ApartmentWithDecorationChange,
  boolean
>;

export type TFilterActions =
  | TRegionChange
  | TRoomsChange
  | TMinPriceChange
  | TMaxPriceChange
  | TMinAreaChange
  | TMaxAreaChange
  | TDeadlineChange
  | TDeadlineVariantsChange
  | TReadyApartmentChange
  | TApartmentWithDecorationChange;

export function regionChange(region: number): TThunkAction<void> {
  return (dispatch, getState) => {
    const { filter } = getState();
    dispatch(residentialComplexesIdsChange({ ...filter, location: region }));
    dispatch({ type: EFilterActionTypes.RegionChange, payload: region });
    dispatch(specialPromosBlocksRefresh(region));
  };
}
export function roomsChange(rooms: ERoom[]): TThunkAction<void> {
  return (dispatch, getState) => {
    const { filter } = getState();

    dispatch(residentialComplexesIdsChange({ ...filter, rooms }));
    dispatch({ type: EFilterActionTypes.RoomsChange, payload: rooms });
  };
}
export function minPriceChange(minPrice: TNumberInputs): TThunkAction<void> {
  return (dispatch, getState) => {
    const { filter } = getState();

    dispatch(residentialComplexesIdsChange({ ...filter, minPrice }));
    dispatch({ type: EFilterActionTypes.MinPriceChange, payload: minPrice });
  };
}
export function maxPriceChange(maxPrice: TNumberInputs): TThunkAction<void> {
  return (dispatch, getState) => {
    const { filter } = getState();

    dispatch(residentialComplexesIdsChange({ ...filter, maxPrice }));
    dispatch({ type: EFilterActionTypes.MaxPriceChange, payload: maxPrice });
  };
}
export function minAreaChange(minArea: TNumberInputs): TThunkAction<void> {
  return (dispatch, getState) => {
    const { filter } = getState();

    dispatch(residentialComplexesIdsChange({ ...filter, minArea }));
    dispatch({ type: EFilterActionTypes.MinAreaChange, payload: minArea });
  };
}
export function maxAreaChange(maxArea: TNumberInputs): TThunkAction<void> {
  return (dispatch, getState) => {
    const { filter } = getState();

    dispatch(residentialComplexesIdsChange({ ...filter, maxArea }));
    dispatch({ type: EFilterActionTypes.MaxAreaChange, payload: maxArea });
  };
}
export function deadlineChange(deadline: TNumberInputs): TThunkAction<void> {
  return (dispatch, getState) => {
    const { filter } = getState();

    dispatch(residentialComplexesIdsChange({ ...filter, deadline }));
    dispatch({ type: EFilterActionTypes.DeadlineChange, payload: deadline });
  };
}
export function readyApartmentsChange(readyApartments: boolean): TThunkAction<void> {
  return (dispatch, getState) => {
    const { filter } = getState();

    dispatch(residentialComplexesIdsChange({ ...filter, readyApartments }));
    dispatch({ type: EFilterActionTypes.ReadyApartmentChange, payload: readyApartments });
  };
}
export function apartmentsWithDecorationChange(apartmentsWithDecoration: boolean): TThunkAction<void> {
  return (dispatch, getState) => {
    const { filter } = getState();

    dispatch(residentialComplexesIdsChange({ ...filter, apartmentsWithDecoration }));
    dispatch({ type: EFilterActionTypes.ApartmentWithDecorationChange, payload: apartmentsWithDecoration });
  };
}
